import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const m = window.location.hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login");
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", { session_id: sessionId });
        setUser(r.data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { state: { user: r.data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Anmeldung fehlgeschlagen.";
        navigate("/login", { state: { error: msg } });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white text-gray-600">
      <div className="flex items-center gap-3" data-testid="auth-callback-loading">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span className="text-sm">Anmeldung wird verarbeitet…</span>
      </div>
    </div>
  );
}
